export default "ui-chart-bar{display:block;margin:0 auto}ui-chart-bar[labels-under-bar] .highcharts-xaxis .highcharts-axis-line{stroke-width:0}\n";